import { Routes } from '@angular/router';
import { SuperUserTenantGuard } from '@shared/guards/super-user-tenant.guard';
import { UserGuard } from '@shared/guards/user.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'auth',
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.routes').then((r) => r.AuthRoutes),
  },
  {
    path: 'analytics',
    canActivateChild: [UserGuard],
    loadComponent: () =>
      import('./modules/analytics/analytics.component').then(
        (c) => c.AnalyticsComponent,
      ),
    loadChildren: () =>
      import('./modules/analytics/analytics.routes').then(
        (r) => r.AnalyticsRoutes,
      ),
  },
  {
    path: 'management',
    canActivateChild: [SuperUserTenantGuard],
    loadComponent: () =>
      import('./modules/management/management.component').then(
        (c) => c.ManagementComponent,
      ),
    loadChildren: () =>
      import('./modules/management/management.routes').then(
        (r) => r.ManagementRoutes,
      ),
  },
  {
    path: 'user',
    canActivateChild: [UserGuard],
    loadComponent: () =>
      import('./modules/user/user.component').then((c) => c.UserComponent),
    loadChildren: () =>
      import('./modules/user/user.routes').then((r) => r.UserRoutes),
  },
  {
    path: 'reporting',
    canActivateChild: [UserGuard],
    loadComponent: () =>
      import('./modules/reporting/reporting.component').then(
        (c) => c.ReportingComponent,
      ),
    loadChildren: () =>
      import('./modules/reporting/reporting.routes').then(
        (r) => r.ReportingRoutes,
      ),
  },
];
